import React, { memo } from 'react'
import { Grid } from '@mui/material'
import Countdown, { zeroPad } from 'react-countdown'

import Text from '../shared/text/Text'

const TimeElapsed = ({ t, endTime, sx, onComplete }) => {
  const renderer = ({ days, hours, minutes, seconds }) => {
    const data = [
      {
        label: 'hours',
        value: hours + days * 24
      },
      {
        label: 'mins',
        value: minutes
      },
      {
        label: 'seconds',
        value: seconds,
        noBorder: true
      }
    ]
    return data.map(({ label, value, noBorder }, index) => (
      <Grid
        item
        key={index}
        xs={4}
        sm={3}
        sx={{
          height: '100%',
          display: 'grid',
          placeItems: 'center',
          placeContent: 'center',
          gap: 1,
          ...(!noBorder && {
            borderRight: {
              xs: '0',
              sm: '1px solid'
            }
          })
        }}
      >
        <Text
          variant='h2'
          label={zeroPad(value)}
          fontWeight={900}
          sx={{ fontSize: 60, lineHeight: 1 }}
        />
        <Text
          variant='h6'
          label={t(`home.${label}`)}
          fontWeight={500}
          color='text.secondary'
        />
      </Grid>
    ))
  }
  return (
    <Grid container spacing={0} justifyContent='end' sx={sx}>
      {endTime !== 0 && (
        <Countdown date={endTime} renderer={renderer} onComplete={onComplete} />
      )}
    </Grid>
  )
}

export default memo(TimeElapsed)
